import React from "react";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import { breadcrumbs } from "../../common/breadcrumbs";
import { customer_voice } from "../../common/customer_voice";
import Tab from "semantic-ui-react/dist/commonjs/modules/Tab";
import { Link } from "../../lib/Link";
import { getUrl } from "../../lib/masterUtil";
import { TopBanner } from "../../common/TopBanner";
import { bike, okunai, okugai, premium } from "./lineup/index"

export const lineup_tab = (type, tabType, history) => {
  const panes = [
    {
      menuItem: "屋外型",
      pane: {
        key: "okugai",
        content: okugai({ type }),
      },
    },
    {
      menuItem: "屋内型",
      pane: {
        key: "okunai",
        content: okunai({ type }),
      },
    },
    {
      menuItem: "トランクハウス24",
      pane: {
        key: "premium",
        content: premium({ type }),
      },
    },
    {
      menuItem: "バイク専用",
      pane: {
        key: "bike",
        content: bike({ type }),
      },
    },
  ];

  let activeTab = null,
    searchLink = null;
  switch (tabType) {
    case "contena":
      activeTab = 0;
      document.title =
        "トランクルームをお探しなら『ハローストレージ』【公式】｜商品ラインナップ｜屋外型";
      searchLink = getUrl({ condition: { assetType: ["okugai"] } });
      break;
      case "trunk":
      activeTab = 1;
      document.title =
        "トランクルームをお探しなら『ハローストレージ』【公式】｜商品ラインナップ｜屋内型";
      searchLink = getUrl({ condition: { assetType: ["okunai"] } });
      break;
    case "premium":
      activeTab = 2;
      document.title =
        "トランクルームをお探しなら『ハローストレージ』【公式】｜商品ラインナップ｜トランクハウス24シリーズ";
      searchLink = getUrl({ condition: { assetType: ["okunai"] } });
      break;
    case "bike":
      activeTab = 3;
      document.title =
        "トランクルームをお探しなら『ハローストレージ』【公式】｜商品ラインナップ｜バイク専用";
      searchLink = getUrl({ condition: { assetType: ["bikeonly"] } });
      break;
    default:
      activeTab = 0;
      document.title =
        "トランクルームをお探しなら『ハローストレージ』【公式】｜商品ラインナップ｜屋外型";
      searchLink = getUrl({ condition: { assetType: ["okugai"] } });
      break;
  }
  const onTabChange = (event, data) => {
    console.log(event, data);
    const nextTabType = ["contena", "trunk", "premium", "bike"][
      data.activeIndex
    ];
    history.push(`/lineup/${nextTabType}/`, { linkType: 'tab' });
  };

  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "商品ラインナップ" }])}

      <div className="lineup">
        <div className="toppanel">
          <div>
            <div className="title">商品ラインナップ</div>
            <div className="text">
              <span>トランクルームなど弊社が提供している</span>
              <span>サービスの概要をご説明しています。</span>
              <span>初めての方は是非お読みください。</span>
            </div>
          </div>
        </div>
        <div className="content">
          <Tab
            panes={panes}
            onTabChange={onTabChange}
            renderActiveOnly={false}
            activeIndex={activeTab || 0}
          />
        </div>
        {type == TYPE_SP ? customer_voice(type, true) : ""}
        <div className="bottompanel inside">
          <div>
            <Link to={searchLink} className="btn black">
              トランクルームを探す
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/lineup_tab.jsx